import React from 'react';
import { R } from '@leverege/value-resolver';
import { alertLabels, alertVariants } from '../attributes/DeviceHealth';
import { AlertPopup } from '../../attributes/renderers/vehicle/index';
export default {
  objectType: 'locator',
  attrName: 'locator.deviceHealth',
  renderer: (data, props, context) => {
    if (data.value && data.value.length) {
      const vin = context?.target?.[0]?.data?.data?.vin;
      return /*#__PURE__*/React.createElement(AlertPopup, {
        value: data.value,
        vin,
        alertLabels: R(alertLabels),
        alertVariants,
        defaultFirstPillVariant: 'pillError',
        defaultLastPillVariant: 'pillError',
        table: true
      });
    }
    return null;
  }
};